import { TranslatedString } from "../translated-string";

export const MANIFESTATION_SCHEMAS = [
    "identificationSchema",
    "descriptionSchema",
    "linkSchema",
    "historySchema",
    "eventsSchema",
    "productContentSchema",
    "packagingSchema",
]

export const MUSEUM_MANIFESTATION_SCHEMAS = MANIFESTATION_SCHEMAS.concat([
    "languageSchema",
    "colorCharacteristicsManifestationSchema",
    "linkToWork",
    "linkToExpression",
    "numismaticsPhilatelyManifestationSchema",
])

export const PHYSICAL_MUSEUM_MANIFESTATION_SCHEMAS = MUSEUM_MANIFESTATION_SCHEMAS.concat([
    "manifestationModeUniverseSchema",
])

export interface Manifestation {
    id: string
    type: string
    entityType?: string
    descriptionSchema: any

    /*identificationSchema?: IdentificationManifestationSchemaResource 
    descriptionSchema?: DescriptionManifestationSchemaResource
    linkSchema?: LinkManifestationSchemaResource
    historySchema?: HistoryManifestationSchemaResource
    eventsSchema?: EventManifestationSchemaResource
    productContentSchema?: ProductContentSchemaResource
    packagingSchema?: PackagingSchemaResource*/
}

interface DescriptionManifestationSchemaResource {
    /*domain?: string[] // array of ref to thesaurusTerm 
    denominations?: DenominationResource[]
    appellations?: AppellationResource[]
    titles?: TitleResource[]
    otherDesignations?: OtherDesignationResource[]
    manufacturers?: ManufacturerResource[]
    originalPresentations?: PresentationResource[]
    creationDates?: CreationDateResource[]
    creationPeriods?: PrecisionPeriodResource[]
    creationLocations?: PrecisionLocationResource[]
    descriptions?: TypedTextResource[]
    typeOfPhysical?: string[]
    typeOfNumeric?: string[]
    materialAndTechniques?: MaterialTechniqueResource[]
    media?: MediumResource[]
    quantityOfMaterials?: MaterialItemResource[]
    formats?: TypedTextResource[]
    measurements?: MeasurementResource[]
    operatingTypes?: OperatingTypeResource[]
    recordPattern?: RecordPatternManifestationResource 
    decorations?: DecorationResource[]
    soundCharacteristics?: SoundCharacteristicsResource
    fileNames?: FileNameResource[]
    fileTypes?: FileTypeResource[]
    beginTimecode?: TranslatedString
    endTimecode?: TranslatedString
    timecodes?: TimecodeResource[]
    shapes?: ShapeResource[]*/
}

interface MaterialTechniqueResource {
    materials?: MaterialResource[]
    techniques?: TechniqueResource[]
    precision?: TranslatedString
    notes?: TranslatedString[]
}

export interface MaterialResource {
    material?: string | null // ref to thesaurus term
    color?: string[] | null // ref to thesaurus term
    precision?: TranslatedString | null
    provider?: string[] | null // ref to thesaurus term
}

export interface TechniqueResource {
    technique?: string | null // ref to thesaurus term
    color?: string | null // ref to thesaurus term
    precision?: TranslatedString | null
}

export interface MeasurementResource {
    measures?: MeasureResource[]
    precision?: TranslatedString
    notes?: TranslatedString[]
    measurement?: TranslatedString
}

interface MeasureResource {
    typeOfMeasure?: string // ref to thesaurus term
    value?: TranslatedString
    unit?: string // ref to thesaurus term
    precision?: TranslatedString
}

export interface TypedTextResource {
    type?: TranslatedString
    content?: TranslatedString
}

export interface DenominationResource {
    denomination?: string | null // ref to thesaurus term
    qualifier?: string[] | null // array of ref to thesaurus term
    precision?: TranslatedString | null
    notes?: TranslatedString[] | null
}